// This file contains the code that will be executed ONLY ONCE the first time
// the client runs the application code.
import { addLocaleData } from 'react-intl';
import JsCookie from 'js-cookie';
import RavenUtils from './utils/raven';
import { errorEvent } from './tracking/eventDefinitions';

function computeAbsoluteUrl(urlPath = '') {
  return decodeURI(
    `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }/${urlPath}`
  );
}

if (typeof window !== 'undefined') {
  // TODO: gllamas PROD-671 Remove cookie deletion code in a month
  JsCookie.remove('trovit_show_cookie_advice');
  JsCookie.remove('trovit_show_gdpr_cookie_banner');

  // Initiallize Sentry.io client.
  const { client, env } = window.__NEXT_DATA__.props.pageProps.initialProps.config; // eslint-disable-line no-underscore-dangle

  const sentryConfig = RavenUtils.createConfigFrom({
    version: env.version,
    environment: env.environment,
    appEnvironment: env.appEnvironment,
    hostname: env.hostname,
    domain: env.domain,
  });

  const Raven = RavenUtils.getRavenInstance(client.sentryPublicKey, sentryConfig);

  // Log unhandled promise rejections on the client side
  // this is a first iteration to avoid noise on Sentry
  // @see https://github.com/getsentry/raven-js/issues/424#issuecomment-173698832
  window.addEventListener('unhandledrejection', e => {
    e.preventDefault();
    const reason = e.reason;

    if (reason instanceof Error) {
      Raven.captureException(reason);
    } else if (reason instanceof DOMException) {
      // That error occurs when the user has filled his device disk capacity, therefore we ignore it.
      if (
        reason.code === 22 ||
        reason.name === 'QUOTA_EXCEEDED_ERR' ||
        reason.name === 'QuotaExceededError'
      ) {
        return false;
      }
      Raven.captureException(new Error(`DOMexception - ${reason.code} - ${reason.name}`));
    }

    return true;
  });

  // Register React Intl's locale data for the user's locale in the browser. This
  // locale data was added to the page by `pages/_document.js`. This only happens
  // once, on initial page load in the browser.
  if (window.ReactIntlLocaleData) {
    Object.keys(window.ReactIntlLocaleData).forEach(lang => {
      addLocaleData(window.ReactIntlLocaleData[lang]);
    });
  } else {
    Raven.captureException(new Error('No locales found in window.ReactIntlLocaleData'));
  }

  // Install service worker
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const serviceWorkerPath = computeAbsoluteUrl('service-worker.js');

      navigator.serviceWorker.register(serviceWorkerPath).then(
        registration => {
          // Registration was successful
          console.log('ServiceWorker registration successful with scope: ', registration.scope); // eslint-disable-line no-console
        },
        err => {
          if (typeof dataLayer !== 'undefined') {
            const formattedEvent = errorEvent({ error: err });
            const tagManagerEvent = Object.assign({}, formattedEvent, {
              event: formattedEvent.hitType,
            });
            dataLayer.push(tagManagerEvent); // eslint-disable-line no-undef
          }
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./app/clientInitialization.js